export default function LabelOutliersIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="13"
      height="14"
      viewBox="0 0 13 14"
      fill="none"
    >
      <path
        d="M11.333 7.83203C11.4517 7.71336 11.5671 7.57116 11.6735 7.41397C12.0138 6.91116 12.2613 6.25484 12.2239 5.72347L12.0582 3.36332C11.9755 2.18485 11.045 1.25432 9.86651 1.17158L7.50636 1.00588C6.80886 0.956914 6.12068 1.21549 5.62242 1.71375L1.71374 5.62243C0.771102 6.56507 0.76085 8.08314 1.69084 9.01313L4.2167 11.539C4.90799 12.2303 5.92422 12.402 6.7875 12.0575"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.33301 11.332C8.33301 11.8625 8.54372 12.3712 8.91879 12.7462C9.29387 13.1213 9.80257 13.332 10.333 13.332C10.8634 13.332 11.3721 13.1213 11.7472 12.7462C12.1223 12.3712 12.333 11.8625 12.333 11.332C12.333 10.8016 12.1223 10.2929 11.7472 9.91782C11.3721 9.54274 10.8634 9.33203 10.333 9.33203C9.80257 9.33203 9.29387 9.54274 8.91879 9.91782C8.54372 10.2929 8.33301 10.8016 8.33301 11.332Z"
        stroke="currentColor"
        strokeWidth="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.99902 12.6628L11.6657 9.99609"
        stroke="currentColor"
        strokeWidth="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
